import React, { Component, ComponentType } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../redux/reducers';
import { ConfigProvider } from 'antd';
import enGB from 'antd/es/locale/en_GB';
import plPL from 'antd/es/locale/pl_PL';
import moment from 'moment';
import 'moment/locale/pl';

interface MapStateToProps {
  /** aktualny język aplikacji */
  currentLanguage: string;
}

interface ComponentProps {
  id: number;
}
export type AntdConfigProviderProps = ComponentProps & MapStateToProps;

/**
 * HOC opakowujący ConfigProviderem z biblioteki 'Ant Design' odpowiadającym za dostarczanie poprawnej wersji językowej do biblioteki.
 *
 * @param Cmp
 */
const withAntdConfigProvider = <P extends ComponentProps>(Cmp: ComponentType<P>) => {
  class Controller extends Component<AntdConfigProviderProps> {
    locale = () => {
      switch (this.props.currentLanguage) {
        case 'en': {
          moment.locale('en');
          return enGB;
        }
        default: {
          moment.locale('pl');
          return plPL;
        }
      }
    };
    render(): React.ReactElement {
      const { currentLanguage, ...props } = this.props;
      return (
        <ConfigProvider locale={this.locale()}>
          <Cmp {...(props as P)} />
        </ConfigProvider>
      );
    }
  }
  return connect(mapStateToProps)(Controller);
};

const mapStateToProps = (state: RootState): MapStateToProps => ({
  currentLanguage: state.AppConfig.currentLanguage,
});

export default withAntdConfigProvider;
